import { NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import localeAr from '@angular/common/locales/ar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';

import { SharedModule } from '@shared';
import { MaterialModule } from 'src/material-module';

import { ToolBarComponent } from './components/tool-bar/tool-bar.component';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { KeyboardShortcutsHelpComponent } from './components/keyboard-shortcuts-help/keyboard-shortcuts-help.component';
import { LockScreenComponent } from './components/lock-screen/lock-screen.component';
import { PreviewFeaturesComponent } from './components/preview-features/preview-features.component';
import { QuickActionsComponent } from './components/quick-actions/quick-actions.component';
import { SideNavLinkComponent } from './components/side-nav-link/side-nav-link.component';
import { UpdateAppVersionDialogComponent } from './components/update-app-version-dialog/update-app-version-dialog.component';
import { MultiTabsBlockingDialogComponent } from './components/multi-tabs-blocking-dialog/multi-tabs-blocking-dialog.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { SetPassCodeComponent } from './components/set-pass-code/set-pass-code.component';
import { CallbackComponent } from './components/callback/callback.component';
import { PreferredOrgProgressComponent } from './components/preferred-org-progress/preferred-org-progress.component';
import { SelectOrganizationComponent } from './components/select-organization/select-organization.component';
import { OrganizationSwitcherComponent } from './components/organization-switcher/organization-switcher.component';
import { BlockedEntityComponent } from './components/blocked-entity/blocked-entity.component';

registerLocaleData(localeAr, 'ar');

@NgModule({
  declarations: [
    ToolBarComponent,
    NavMenuComponent,
    LockScreenComponent,
    QuickActionsComponent,
    KeyboardShortcutsHelpComponent,
    PreviewFeaturesComponent,
    SideNavLinkComponent,
    UpdateAppVersionDialogComponent,
    MultiTabsBlockingDialogComponent,
    UnauthorizedComponent,
    SetPassCodeComponent,
    CallbackComponent,
    PreferredOrgProgressComponent,
    SelectOrganizationComponent,
    OrganizationSwitcherComponent,
    BlockedEntityComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    KeyboardShortcutsModule.forRoot(),
    TranslateModule,
    MaterialModule,
    SharedModule,
    BrowserAnimationsModule
  ],
  exports: [
    ToolBarComponent,
    NavMenuComponent,
    LockScreenComponent,
    QuickActionsComponent
  ]
})
export class CoreModule { }
